import { Component, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Campania } from '../../_models/campania';
import { CampaniaService } from '../../_services/campania.service';
import { CampaniaDctoCiclos } from '../../_models/campania-dcto-ciclos';

@Component( {
  selector: 'app-campanias-listado',
  templateUrl: 'campanias-listado.component.html'
} )

export class CampaniasListadoComponent implements OnInit {
  campania: Campania;
  campanias: Campania[];
  carCampanias = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

    constructor( private camServicio: CampaniaService,
               private navServicio: NavService,
               private autServicio: AutenticacionService,
               private router: Router ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/campanias' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'CAMPANIA.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'CAMPANIA.LBL_NOMBRE' ), sort: true },
      {field: 'fechaInicio', header: this.navServicio.buscarMensaje('CAMPANIA.LBL_FECHAINICIO'), sort: false},
      {field: 'fechaFin', header: this.navServicio.buscarMensaje('CAMPANIA.LBL_FECHAFIN'), sort: false},
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.cargarServicios();
  }
  cargarServicios() {
    this.busqueda = this.navServicio.getSearch( 'campania.component' );

    this.camServicio.listadoCampaniasHabilitadas().subscribe( campanias => {
      this.campanias = campanias;
      this.carCampanias = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crearCampania() {
    this.router.navigate(['apl/campanias/agregar']);
  }

  verCampania( campania: Campania ) {
    this.router.navigate( [ 'apl/campanias/detalle/' + campania.idCampania ] );
  }

  editarCampania( campania: Campania ) {
    this.router.navigate( [ 'apl/campanias/actualizar/' + campania.idCampania ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'campania.component', this.busqueda );
  }
  eliminarCampania( campania: Campania ) {
    this.campania = campania;
    this.campania.indicadorHabilitado = false;
    this.camServicio.actualizar( campania ).subscribe( rta => {
      this.campania = null;
      this.cargarServicios();
      this.carCampanias = false;
      this.navServicio.setMesage( 0, {
        severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'CAMPANIADCTOCICLO.LBL_ELIMINARCAMPANIA' )
      } );
    }, error => {
      this.navServicio.setMesage( 3 );
      this.carCampanias = false;
    } );
  }

}
